import api from '../../../../../api/client';
import { ORGANIZATION } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';

export async function getOrganization(params = {}) {
  try {
    const response = await api.get(ORGANIZATION.INDEX, {
      params,
    });
    const data = handleApiResponse(response);
    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
export async function createOrganization(payload = {}) {
  try {
    const response = await api.post(ORGANIZATION.STORE, payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function updateOrganization(id, payload = {}) {
  try {
    const response = await api.post(ORGANIZATION.UPDATE(id), payload);
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function deleteOrganization(id) {
  try {
    const response = await api.delete(ORGANIZATION.DELETE(id));
    const data = handleApiResponse(response);

    return data;
  } catch (error) {
    throw handleApiError(error);
  }
}
